import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {RestaurantServiceService} from '../../restaurant/restaurant-service.service';
import {ToastrService} from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  private resID: number;
  private resMenus: [];
  modalRef: BsModalRef;
  message: string;
  menuObj: any = {};

  p = 1;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private restaurantServices: RestaurantServiceService,
    private modalService: BsModalService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.resID = Number(this.route.snapshot.paramMap.get('id'));
    this.getAllRestaurantMenu();
  }
  onSubmit() {
    this.menuObj.RestroId = this.resID;
    this.restaurantServices.setRestaurantMenu(this.menuObj).subscribe(response => {
        this.toastr.success('Menu added successfully!', 'Success');
        this.menuObj.Name = '';
        this.getAllRestaurantMenu();

      // }
    });
  }
  getAllRestaurantMenu() {
    this.restaurantServices.getRestaurantMenuById(this.resID).subscribe(response => {
      if (response.length > 0) {
        this.resMenus = response;
        // this.toastr.success('Menu fetched successfully', 'Success');
      } else {
        // this.toastr.error('Failed to fetch data try again!', 'Error');
      }
    });
  }
  navigateTo(id) {
    this.router.navigateByUrl('/meals/' + this.resID + '/' + id );
  }
  decline(): void {
    this.message = 'Declined!';
    this.modalRef.hide();
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-sm'});
  }

  confirm(id): void {
    this.message = 'Confirmed!';
    this.restaurantServices.DeleteMenu(id).subscribe(Response => {
      this.toastr.success('Menu deleted...');
      this.getAllRestaurantMenu();
    });
    this.modalRef.hide();
  }
  UpdateMenuNavigation(id) {
    this.router.navigateByUrl('/updateMenu/' + this.resID + '/' + id);
  }
}
